export default {
  MANUAL: 'MANUAL',
  SYSTEM: 'SYSTEM',
};
